$(document).ready(function () {
    $.ajax({
        type: "GET",
        url: "/products/waterdrop-countertop-electric-dispenser-water-filtration-system.js",
        dataType: "json",
        success: function (product) {
            var goods_price = (product.price / 100).toFixed(2);
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(0)
                .find(".wd-compare-detail-item-product-price")
                .html("$" + goods_price);
            $(".wd-compare-header .wd-compare-header-item")
                .eq(0)
                .find(".wd-compare-header-item-price")
                .html("$" + goods_price);
        },
    });
    $.ajax({
        type: "GET",
        url: "/products/water-filter-pitcher-chubby-blue.js",
        dataType: "json",
        success: function (product) {
            var goods_price = (product.price / 100).toFixed(2);
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(1)
                .find(".wd-compare-detail-item-product-price")
                .html("$" + goods_price);
            $(".wd-compare-header .wd-compare-header-item")
                .eq(1)
                .find(".wd-compare-header-item-price")
                .html("$" + goods_price);
        },
    });
    $.ajax({
        type: "GET",
        url: "/products/elfin-water-filter-pitcher.js",
        dataType: "json",
        success: function (product) {
            var goods_price = (product.price / 100).toFixed(2);
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(2)
                .find(".wd-compare-detail-item-product-price")
                .html("$" + goods_price);
            $(".wd-compare-header .wd-compare-header-item")
                .eq(2)
                .find(".wd-compare-header-item-price")
                .html("$" + goods_price);
        },
    });

    $(window).on("scroll", function () {
        var scrollTop = $(this).scrollTop();
        var offsetTop = $(".wd-compare-content").offset().top;
        if (scrollTop > offsetTop) {
            $(".wd-compare-header").css("display", "block");
        } else {
            $(".wd-compare-header").css("display", "none");
        }
    });

    var wd_compare_index;
    var pre_index;

    var window_width = $(window).width();
    if (window_width <= 1024) {
        $(".wd-compare-product .wd-compare-detail-item-product-choose-card-items")
            .eq(0)
            .find(".wd-compare-detail-item-product-choose-card-item")
            .eq(2)
            .removeClass("wd-compare-detail-item-product-choose-card-item-choosed");
        $(".wd-compare-product .wd-compare-detail-item-product-choose-card-items")
            .eq(1)
            .find(".wd-compare-detail-item-product-choose-card-item")
            .eq(2)
            .removeClass("wd-compare-detail-item-product-choose-card-item-choosed");
    }

    $(".wd-compare-detail-item-product-choose-select").click(function () {
        wd_compare_index = $(this).parents(".wd-compare-detail-item").index();
        pre_index = $(this)
            .siblings(".wd-compare-detail-item-product-choose-card")
            .find(`.wd-compare-detail-item-product-choose-card-item-active`)
            .attr("data-index");

        if (window_width <= 767) {
            $(".wd-compare-detail-item-product-choose-card-popup").css(
                "display",
                "block"
            );
            $(".wd-compare-detail-item-product-choose-select-mobile").css(
                "display",
                "flex"
            );
            $(".wd-compare-detail-item-product-choose-card-popup-close").css(
                "display",
                "block"
            );
            $("html").css("overflow", "hidden");
            $(".wd-compare").css("z-index", "99");
            $(this)
                .siblings(".wd-compare-detail-item-product-choose-select-mobile")
                .css("border-bottom", "1px solid #2179CA");
            $(this)
                .parents(".wd-compare-detail-item")
                .siblings()
                .find(".wd-compare-detail-item-product-choose-select-mobile")
                .css("border-bottom", "1px solid #e2e2e2");
        }
        $(this)
            .parents(".wd-compare-detail-items")
            .find(".wd-compare-detail-item-product-choose-card")
            .stop()
            .slideUp();
        $(this)
            .siblings(".wd-compare-detail-item-product-choose-card")
            .stop()
            .slideDown();
    });

    $(
        ".wd-compare-detail-item-product-choose-select.wd-compare-detail-item-product-choose-select-mobile"
    ).click(function () {
        $(this)
            .parents(".wd-compare-detail-item")
            .siblings()
            .find(".wd-compare-detail-item-product-choose-card")
            .css("display", "none");
        $(this)
            .parents(".wd-compare-detail-item")
            .siblings()
            .find(".wd-compare-detail-item-product-choose-select-mobile")
            .css("border-bottom", "1px solid #e2e2e2");
        $(this)
            .siblings(".wd-compare-detail-item-product-choose-card")
            .css("display", "block");
        $(this).css("border-bottom", "1px solid #2179CA");
    });

    $(".wd-compare-detail-item-product-choose-card").mouseleave(function () {
        $(this).stop().slideUp();
    });
    $(".wd-compare-detail-item-product-choose-card-item").hover(
        function () {
            $(this).addClass("wd-compare-detail-item-product-choose-card-item-hover");
        },
        function () {
            $(this).removeClass(
                "wd-compare-detail-item-product-choose-card-item-hover"
            );
        }
    );
    $(".wd-compare-detail-item-product-choose-card-popup-close").click(
        function () {
            $(this)
                .parents(".wd-compare-detail-items")
                .find(".wd-compare-detail-item-product-choose-card")
                .stop()
                .slideUp();
            $(".wd-compare-detail-item-product-choose-card-popup").css(
                "display",
                "none"
            );
            $(".wd-compare-detail-item-product-choose-select-mobile").css(
                "display",
                "none"
            );
            $(".wd-compare-detail-item-product-choose-card-popup-close").css(
                "display",
                "none"
            );
            $("html").css("overflow", "auto");
            $(".wd-compare").css("z-index", "auto");
        }
    );

    $(".wd-compare-detail-item-product-choose-card-item").click(function () {
        if (
            $(this).hasClass(
                "wd-compare-detail-item-product-choose-card-item-choosed"
            )
        ) {
            return false;
        }
        if (window_width <= 1024) {
            $(this)
                .parents(".wd-compare-detail-items")
                .find(".wd-compare-detail-item-product-choose-card")
                .stop()
                .slideUp();
            $(".wd-compare").css("z-index", "auto");
        }
        if (window_width <= 767) {
            $(this)
                .parents(".wd-compare-detail-items")
                .find(".wd-compare-detail-item-product-choose-card")
                .stop()
                .slideUp();
            $(".wd-compare-detail-item-product-choose-card-popup").css(
                "display",
                "none"
            );
            $(".wd-compare-detail-item-product-choose-select-mobile").css(
                "display",
                "none"
            );
            $(".wd-compare-detail-item-product-choose-card-popup-close").css(
                "display",
                "none"
            );
            $("html").css("overflow", "auto");
        }

        var data_index = $(this).attr("data-index");
        if (data_index !== pre_index) {
            $(".wd-compare-detail-item-product-choose-card-items")
                .find(`[data-index="${pre_index}"]`)
                .removeClass("wd-compare-detail-item-product-choose-card-item-choosed");
            pre_index = data_index;
        }
        $(this)
            .siblings()
            .removeClass("wd-compare-detail-item-product-choose-card-item-active");
        $(this).addClass("wd-compare-detail-item-product-choose-card-item-active");
        $(this).removeClass(
            "wd-compare-detail-item-product-choose-card-item-choosed"
        );
        $(this)
            .parents(".wd-compare-detail-item")
            .siblings()
            .find(".wd-compare-detail-item-product-choose-card-item")
            .each(function () {
                if ($(this).attr("data-index") === data_index) {
                    $(this).addClass(
                        "wd-compare-detail-item-product-choose-card-item-choosed"
                    );
                }
            });

        var product_title = $(this)
            .find(".wd-compare-detail-item-product-choose-card-item-title")
            .html()
            .trim();

        $(this)
            .parents(".wd-compare-detail-item-product-choose")
            .find(
                ".wd-compare-detail-item-product-choose-select .wd-compare-detail-item-product-choose-name"
            )
            .html(product_title);

        $(this)
            .parents(".wd-compare")
            .find(".wd-compare-header-item")
            .eq(wd_compare_index)
            .find(".wd-compare-header-item-title")
            .html(product_title);
        var product_value = $(this).data("value");
        $.ajax({
            type: "GET",
            url: "/products/" + product_value + ".js",
            dataType: "json",
            success: function (product) {
                var goods_price = (product.price_max / 100).toFixed(2);
                var goods_url = product.url;
                $(".wd-compare-product .wd-compare-detail-item")
                    .eq(wd_compare_index)
                    .find(".wd-compare-detail-item-product-price")
                    .html("$" + goods_price);
                $(".wd-compare-header .wd-compare-header-item")
                    .eq(wd_compare_index)
                    .find(".wd-compare-header-item-price")
                    .html("$" + goods_price);
            },
        });

        edit_info(product_title);
    });

    function edit_info(title) {
        if (title == "PT-04") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/waterdrop-7019B2_4.png?v=1638778482"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/waterdrop-7019B2_4.png?v=1638778482"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/water-filter-pitcher-chubby-blue"
                );

            $(".wd-compare-detail-capacity .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-text">
      10 Cups
  </div>`);
            $(".wd-compare-detail-color .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-text">
          White, Blue, Clear
      </div>`
                );
            $(".wd-compare-detail-product_dimesions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835" alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                        10.4 x 5.3 x 10.0 inches
                        </div>`
                );

            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-text">
          2.3 lbs
      </div>
          `
                );
            $(".wd-compare-detail-electricity_required .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
                        </div>
        `);

            $(".wd-compare-detail-handle .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-text">
                            Natural Wooden Handle
                        </div>
          `
                );
            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-img">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-kettle-nsf.jpg?v=1690160866" alt="">
                        </div>
    `);
            $(".wd-compare-detail-tds .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
                        </div>
        `);
            $(".wd-compare-detail-reduce_substance .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-longtext">
      Effectively filters out harmful substances, such as residual chlorine, limescale, odor, and heavy metals
  </div>
          `);
            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-a">
      <a href="https://www.waterdropfilter.com/products/waterdrop-water-pitcher-filter-replacement-wd-pf-01a-3">
          <div class="wd-compare-detail-item-img">
              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/products/wd-pf-01a.png?v=1611900519"
                  alt="">
          </div>
          <div class="wd-compare-detail-item-text">
              WD-PF-01A-3
          </div>
          <div class="wd-compare-detail-item-text">
              3 months
          </div>
      </a>
  </div>
        `);
            $(".wd-compare-detail-average .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-average-svg.svg?v=1682313835"
                                alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                            $39.99
                        </div>
          `);
            $(".wd-compare-detail-smart .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">
                        </div>
            `);
        } else if (title == "PT-05") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/7015_1_4076b8b8-902d-49af-9dd0-0cfde005a719.png?v=1674983568"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/7015_1_4076b8b8-902d-49af-9dd0-0cfde005a719.png?v=1674983568"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/elfin-water-filter-pitcher"
                );

            $(".wd-compare-detail-capacity .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-text">
      5 Cups
  </div>`);
            $(".wd-compare-detail-color .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-text">
          White, Pink, Green, Blue, Yellow
      </div>`
                );
            $(".wd-compare-detail-product_dimesions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835" alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                        9.6 x 4.1 x 10.0 inches
                        </div>`
                );

            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-text">
          1.84 lbs
      </div>
          `
                );
            $(".wd-compare-detail-electricity_required .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
                        </div>
        `);

            $(".wd-compare-detail-handle .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-text">
          Ergonomic Handle
                        </div>
          `
                );
            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-img">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-kettle-nsf.jpg?v=1690160866" alt="">
                        </div>
    `);
            $(".wd-compare-detail-tds .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
                        </div>
        `);
            $(".wd-compare-detail-reduce_substance .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-longtext">
      Effectively filters out harmful substances, such as residual chlorine, limescale, odor, and heavy metals
  </div>
          `);
            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-a">
      <a href="https://www.waterdropfilter.com/products/waterdrop-water-pitcher-filter-replacement-wd-pf-01a-3">
          <div class="wd-compare-detail-item-img">
              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/products/wd-pf-01a.png?v=1611900519"
                  alt="">
          </div>
          <div class="wd-compare-detail-item-text">
              WD-PF-01A-3
          </div>
          <div class="wd-compare-detail-item-text">
              3 months
          </div>
      </a>
  </div>
        `);
            $(".wd-compare-detail-average .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-average-svg.svg?v=1682313835"
                                alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                            $39.99
                        </div>
          `);
            $(".wd-compare-detail-smart .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">
                        </div>
            `);
        } else if (title == "PT-07") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/7017_1_47dacd1c-4910-4f0f-9160-27886ecd4b33.png?v=1652698148"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/7017_1_47dacd1c-4910-4f0f-9160-27886ecd4b33.png?v=1652698148"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/water-pitcher-with-filter"
                );

            $(".wd-compare-detail-capacity .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-text">
      10 Cups
  </div>`);
            $(".wd-compare-detail-color .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-text">
          Classic Blue, White, Blue
      </div>`
                );
            $(".wd-compare-detail-product_dimesions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835" alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                        10.0 x 5.3 x 10.0 inches
                        </div>`
                );

            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-text">
          1.98 lbs
      </div>
          `
                );
            $(".wd-compare-detail-electricity_required .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
                        </div>
        `);

            $(".wd-compare-detail-handle .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-text">
          Ergonomic Handle
                        </div>
          `
                );
            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-img">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-kettle-nsf.jpg?v=1690160866" alt="">
                        </div>
    `);
            $(".wd-compare-detail-tds .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
                        </div>
        `);
            $(".wd-compare-detail-reduce_substance .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-longtext">
      Effectively reduce arsenic, fluoride, lead, and other contaminants in water
  </div>
          `);
            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-a">
      <a href="https://www.waterdropfilter.com/products/waterdrop-water-pitcher-filter-replacement-wd-pf-01a-3">
          <div class="wd-compare-detail-item-img">
              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/products/wd-pf-01a.png?v=1611900519"
                  alt="">
          </div>
          <div class="wd-compare-detail-item-text">
              WD-PF-01A-3
          </div>
          <div class="wd-compare-detail-item-text">
              3 months
          </div>
      </a>
  </div>
        `);
            $(".wd-compare-detail-average .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-average-svg.svg?v=1682313835"
                                alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                            $39.99
                        </div>
          `);
            $(".wd-compare-detail-smart .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">
                        </div>
            `);
        } else if (title == "WFD-22") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/Waterdrop-dispenser-main.png?v=1739948298"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/Waterdrop-dispenser-main.png?v=1739948298"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/water-filter-dispenser"
                );

            $(".wd-compare-detail-capacity .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-text">
      20 Cups
  </div>`);
            $(".wd-compare-detail-color .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-text">
          Black, Turquoise
      </div>`
                );
            $(".wd-compare-detail-product_dimesions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835" alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                        12.4 × 8.5 × 8.7 inches
                        </div>`
                );

            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-text">
          3.41 lbs
      </div>
          `
                );
            $(".wd-compare-detail-electricity_required .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
                        </div>
        `);

            $(".wd-compare-detail-handle .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-text">
          Push-and-pull design
                        </div>
          `
                );
            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-img">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-kettle-nsf.jpg?v=1690160866" alt="">
                        </div>
    `);
            $(".wd-compare-detail-tds .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
                        </div>
        `);
            $(".wd-compare-detail-reduce_substance .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-longtext">
      Reduce arsenic, fluoride, lead, and other contaminants
  </div>
          `);
            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-a">
      <a href="https://www.waterdropfilter.com/products/waterdrop-water-pitcher-filter-replacement-wd-pf-01a-3">
          <div class="wd-compare-detail-item-img">
              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/products/wd-pf-01a.png?v=1611900519"
                  alt="">
          </div>
          <div class="wd-compare-detail-item-text">
              WD-PF-01A-3
          </div>
          <div class="wd-compare-detail-item-text">
              3 months
          </div>
      </a>
  </div>
        `);
            $(".wd-compare-detail-average .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-average-svg.svg?v=1682313835"
                                alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                            $39.99
                        </div>
          `);
            $(".wd-compare-detail-smart .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">
                        </div>
            `);
        } else if (title == "ED01") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/7_8520519d-6e0f-4eeb-9e62-c1a9652e8e65.png?v=1689318129"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/7_8520519d-6e0f-4eeb-9e62-c1a9652e8e65.png?v=1689318129"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/waterdrop-countertop-electric-dispenser-water-filtration-system"
                );

            $(".wd-compare-detail-capacity .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-text">
      15 Cups
  </div>`);
            $(".wd-compare-detail-color .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-text">
          White, Blue
      </div>`
                );
            $(".wd-compare-detail-product_dimesions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835" alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                        7 x 9.7 x 10.2 inches
                        </div>`
                );

            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-text">
          4.33 lbs
      </div>
          `
                );
            $(".wd-compare-detail-electricity_required .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">
                        </div>
        `);

            $(".wd-compare-detail-handle .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-text">
          Ergonomic Handle
                        </div>
          `
                );
            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-img">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-kettle-nsf.jpg?v=1690160866" alt="">
                        </div>
    `);
            $(".wd-compare-detail-tds .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
                        </div>
        `);
            $(".wd-compare-detail-reduce_substance .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-longtext">
      Reduces 30+ harmful substances in water such as chlorine, lead, taste&odor, mercury, PFOS, PFOA, benzene, carbofuran, bisphenol A , o-Dichlorobenzene, 1, 2, 4-Trichlorobenzene, atrazine, toxaphene, lindane, cyst, endrin, MTBE, diethylstilbestrol, phenylbutazone, naproxen ......
  </div>
          `);
            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-a">
      <a href="https://www.waterdropfilter.com/products/waterdrop-countertop-electric-dispenser-water-filtration-system">
          <div class="wd-compare-detail-item-img">
              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/WD-7050_shopify-20230709-10.png?v=1688995856"
                  alt="">
          </div>
          <div class="wd-compare-detail-item-text">
          WD-EDF
          </div>
          <div class="wd-compare-detail-item-text">
          3 months
          </div>
      </a>
  </div>
        `);
            $(".wd-compare-detail-average .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-average-svg.svg?v=1682313835"
                                alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                        $55.99
                        </div>
          `);
            $(".wd-compare-detail-smart .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">
                        </div>
            `);
        } else if (title == "ED01A") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-ed01ab-new.png?v=1729771646"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-ed01ab-new.png?v=1729771646"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/collections/pitcher-water-filter/products/countertop-electric-water-pitcher-ed01a"
                );

            $(".wd-compare-detail-capacity .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-text">
      15 Cups
  </div>`);
            $(".wd-compare-detail-color .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-text">
          White, Blue
      </div>`
                );
            $(".wd-compare-detail-product_dimesions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835" alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                        7 × 9.7 × 10.2 inches
                        </div>`
                );

            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-text">
          4.33 lbs
      </div>
          `
                );
            $(".wd-compare-detail-electricity_required .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">
                        </div>
        `);

            $(".wd-compare-detail-handle .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-text">
          Ergonomic Handle
                        </div>
          `
                );
            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-img">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-kettle-nsf.jpg?v=1690160866" alt="">
                        </div>
    `);
            $(".wd-compare-detail-tds .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
                        </div>
        `);
            $(".wd-compare-detail-reduce_substance .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-longtext">
      Reduces 30+ harmful substances in water such as chlorine, lead, taste&odor, mercury, PFOS, PFOA, benzene, carbofuran, bisphenol A , o-Dichlorobenzene, 1, 2, 4-Trichlorobenzene, atrazine, toxaphene, lindane, cyst, endrin, MTBE, diethylstilbestrol, phenylbutazone, naproxen ......
  </div>
          `);
            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-a">
      <a href="https://www.waterdropfilter.com/collections/pitcher-water-filter/products/electric-water-dispenser-replacement-filter-edfa">
          <div class="wd-compare-detail-item-img">
              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-edfa.png?v=1729847055"
                  alt="">
          </div>
          <div class="wd-compare-detail-item-text">
          WD-EDFA
          </div>
          <div class="wd-compare-detail-item-text">
          3 months
          </div>
      </a>
  </div>
        `);
            $(".wd-compare-detail-average .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-average-svg.svg?v=1682313835"
                                alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                        $31.99
                        </div>
          `);
            $(".wd-compare-detail-smart .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">
                        </div>
            `);
        } else if (title == "EDC01") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-ed01aw.png?v=1729771439"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-ed01aw.png?v=1729771439"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/collections/pitcher-water-filter/products/countertop-electric-water-dispenser-edc01"
                );

            $(".wd-compare-detail-capacity .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-text">
      15 Cups
  </div>`);
            $(".wd-compare-detail-color .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-text">
          White
      </div>`
                );
            $(".wd-compare-detail-product_dimesions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835" alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                        7 × 9.7 × 10.2 inches
                        </div>`
                );

            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-text">
          4.33 lbs
      </div>
          `
                );
            $(".wd-compare-detail-electricity_required .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">
                        </div>
        `);

            $(".wd-compare-detail-handle .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-text">
          Ergonomic Handle
                        </div>
          `
                );
            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-img">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-kettle-nsf.jpg?v=1690160866" alt="">
                        </div>
    `);
            $(".wd-compare-detail-tds .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
                        </div>
        `);
            $(".wd-compare-detail-reduce_substance .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-longtext">
      Reduces 30+ harmful substances in water such as chlorine, lead, taste&odor, mercury, PFOS, PFOA, benzene, carbofuran, bisphenol A , o-Dichlorobenzene, 1, 2, 4-Trichlorobenzene, atrazine, toxaphene, lindane, cyst, endrin, MTBE, diethylstilbestrol, phenylbutazone, naproxen ......
  </div>
          `);
            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-a">
      <a href="https://www.waterdropfilter.com/collections/pitcher-water-filter/products/water-pitcher-replacement-filter-edfc">
          <div class="wd-compare-detail-item-img">
              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/2_e731e092-e9ec-44be-9330-b42a096b0337.png?v=1730108061"
                  alt="">
          </div>
          <div class="wd-compare-detail-item-text">
          WD-EDFC
          </div>
          <div class="wd-compare-detail-item-text">
          3 months
          </div>
      </a>
  </div>
        `);
            $(".wd-compare-detail-average .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-average-svg.svg?v=1682313835"
                                alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                        $19.66
                        </div>
          `);
            $(".wd-compare-detail-smart .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">
                        </div>
            `);
        } else if (title == "ED02") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-ed02w.png?v=1729771647"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-ed02w.png?v=1729771647"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/collections/pitcher-water-filter/products/electric-water-pitcher-ed02"
                );

            $(".wd-compare-detail-capacity .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-text">
      15 Cups
  </div>`);
            $(".wd-compare-detail-color .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-text">
          White, Blue
      </div>`
                );
            $(".wd-compare-detail-product_dimesions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835" alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                        10.6 ×4.6 ×10.2 inches
                        </div>`
                );

            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-text">
          4.33 lbs
      </div>
          `
                );
            $(".wd-compare-detail-electricity_required .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">
                        </div>
        `);

            $(".wd-compare-detail-handle .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-text">
          Ergonomic Handle
                        </div>
          `
                );
            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-img">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-kettle-nsf.jpg?v=1690160866" alt="">
                        </div>
    `);
            $(".wd-compare-detail-tds .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
                        </div>
        `);
            $(".wd-compare-detail-reduce_substance .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-longtext">
      Reduces 30+ harmful substances in water such as chlorine, lead, taste&odor, mercury, PFOS, PFOA, benzene, carbofuran, bisphenol A , o-Dichlorobenzene, 1, 2, 4-Trichlorobenzene, atrazine, toxaphene, lindane, cyst, endrin, MTBE, diethylstilbestrol, phenylbutazone, naproxen ......
  </div>
          `);
            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-a">
      <a href="https://www.waterdropfilter.com/products/waterdrop-countertop-electric-dispenser-replacement-filter-wd-edf">
          <div class="wd-compare-detail-item-img">
              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-edf.png?v=1729842103"
                  alt="">
          </div>
          <div class="wd-compare-detail-item-text">
          WD-EDF
          </div>
          <div class="wd-compare-detail-item-text">
          3 months
          </div>
      </a>
  </div>
        `);
            $(".wd-compare-detail-average .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-average-svg.svg?v=1682313835"
                                alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                        $18.99
                        </div>
          `);
            $(".wd-compare-detail-smart .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">
                        </div>
            `);
        } else if (title == "ED04") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-ed04-new.png?v=1729771294"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-ed04-new.png?v=1729771294"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/collections/pitcher-water-filter/products/water-filter-pitcher-ed04"
                );

            $(".wd-compare-detail-capacity .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-text">
      27 Cups
  </div>`);
            $(".wd-compare-detail-color .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-text">
          White, Blue
      </div>`
                );
            $(".wd-compare-detail-product_dimesions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835" alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                        7.1 × 12 × 10.2 inches
                        </div>`
                );

            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-text">
          6.04  lbs
      </div>
          `
                );
            $(".wd-compare-detail-electricity_required .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">
                        </div>
        `);

            $(".wd-compare-detail-handle .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-text">
          Ergonomic Handle
                        </div>
          `
                );
            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-img">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-kettle-nsf.jpg?v=1690160866" alt="">
                        </div>
    `);
            $(".wd-compare-detail-tds .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
                        </div>
        `);
            $(".wd-compare-detail-reduce_substance .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-longtext">
      Reduces 30+ harmful substances in water such as chlorine, lead, taste&odor, mercury, PFOS, PFOA, benzene, carbofuran, bisphenol A , o-Dichlorobenzene, 1, 2, 4-Trichlorobenzene, atrazine, toxaphene, lindane, cyst, endrin, MTBE, diethylstilbestrol, phenylbutazone, naproxen ......
  </div>
          `);
            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-a">
      <a href="https://www.waterdropfilter.com/products/waterdrop-countertop-electric-dispenser-replacement-filter-wd-edf">
          <div class="wd-compare-detail-item-img">
              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-edf.png?v=1729842103"
                  alt="">
          </div>
          <div class="wd-compare-detail-item-text">
          WD-EDF
          </div>
          <div class="wd-compare-detail-item-text">
          3 months
          </div>
      </a>
  </div>
        `);
            $(".wd-compare-detail-average .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-average-svg.svg?v=1682313835"
                                alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                        $18.99
                        </div>
          `);
            $(".wd-compare-detail-smart .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">
                        </div>
            `);
        } else if (title == "ED06") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/600.png?v=1728959403"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/600.png?v=1728959403"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/collections/pitcher-water-filter/products/electric-water-filter-pitcher-soft-water-system-ed06w"
                );

            $(".wd-compare-detail-capacity .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-text">
      17 Cups
  </div>`);
            $(".wd-compare-detail-color .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-text">
                    White, Blue, Pink
      </div>`
                );
            $(".wd-compare-detail-product_dimesions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835" alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                        2.03 × 1.33 × 0.98 inches
                        </div>`
                );

            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-text">
          3.42 lbs
      </div>
          `
                );
            $(".wd-compare-detail-electricity_required .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">
                        </div>
        `);

            $(".wd-compare-detail-handle .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
          <div class="wd-compare-detail-item-text">
          Ergonomic Handle
                        </div>
          `
                );
            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-img">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-kettle-nsf.jpg?v=1690160866" alt="">
                        </div>
    `);
            $(".wd-compare-detail-tds .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
                        </div>
        `);
            $(".wd-compare-detail-reduce_substance .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-longtext">
      Reduces 30+ harmful substances in water such as chlorine, lead, taste&odor, mercury, PFOS, PFOA, benzene, carbofuran, bisphenol A , o-Dichlorobenzene, 1, 2, 4-Trichlorobenzene, atrazine, toxaphene, lindane, cyst, endrin, MTBE, diethylstilbestrol, phenylbutazone, naproxen ......
  </div>
          `);
            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-a">
      <a href="https://www.waterdropfilter.com/products/electric-water-pitcher-replacement-filter-ewfs">
          <div class="wd-compare-detail-item-img">
              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/WD-EDFS_-ECF-A002AW____1-03-20240924_V1.jpg?v=1728697935"
                  alt="">
          </div>
          <div class="wd-compare-detail-item-text">
          WD-EWFS
          </div>
          <div class="wd-compare-detail-item-text">
          3 months
          </div>
      </a>
  </div>
        `);
            $(".wd-compare-detail-average .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-average-svg.svg?v=1682313835"
                                alt="">
                        </div>
                        <div class="wd-compare-detail-item-text">
                        $14.99
                        </div>
          `);
            $(".wd-compare-detail-smart .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
                            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">
                        </div>
            `);
        }
    }
});
